import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Add } from "@mui/icons-material";
import {
  validateNumber,
  validateNumberInput,
  validatePercentage,
} from "../../../../utils/validateFields";
import { getRowErrorMessages } from "./Errors";
import DeleteRowDialog from "../../../../Components/Common/DeleteRowDialog";
import DeleteTableDialog from "./DeleteTableDialog";
import { fixedPercentage } from "../../../../utils/common";

const RegionTable = ({
  inputData,
  tables,
  setTables,
  errors,
  setErrors,
  disabled,
  hide,
  field1
}) => {
  console.log("table log", tables);
  // Static categories
  const initialStaticCategories = [
    "Board of Directors (BOD)",
    "KMP except BOD",
    "Other Employees",
    "Workers",
  ];
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [tableToDelete, setTableToDelete] = useState(null);

  const handleAddTable = () => {
    const newTable = {
      region: ``, // Dynamic region naming
      table: initialStaticCategories.map((category) => ({
        employeeCategory: category,
        totalCategory: "",
        antiCorruptionPolicies: "",
        percentage: "",
      })),
    };
    setTables([...tables, newTable]);
  };

  // const isTableComplete = () => {
  //   return tables.every((table) =>
  //     table.table.every(
  //       (row) =>
  //         // row.employeeCategory.trim() !== "" ||
  //         row.totalCategory.trim() !== "" ||
  //         row.antiCorruptionPolicies.trim() !== "" ||
  //         row.percentage.trim() !== ""
  //     )
  //   );
  // };

  const isTableComplete = () => {
    if (tables.length === 0) return false;

    const lastTable = tables[tables.length - 1]; // Check only the last table
    return lastTable.table.some(
      (row) =>
        row.totalCategory.trim() !== "" ||
        row.antiCorruptionPolicies.trim() !== "" ||
        row.percentage.trim() !== ""
    );
  };

  const handleDeleteTable = (index) => {
    const hasData = tables[index].table.some(
      (row) => row.totalCategory || row.antiCorruptionPolicies
    );

    if (hasData) {
      setTableToDelete(index);
      setOpenDeleteDialog(true);
    } else {
      deleteTable(index);
    }
  };

  const deleteTable = (indexToDelete) => {
    const updatedTables = tables
      .filter((_, index) => index !== indexToDelete)
      .map((table, index) => ({
        ...table,
        region: table.region.startsWith("Region")
          ? `Region ${index + 1}`
          : table.region,
      }));

    setTables(updatedTables);
  };

  const handleInputChange = (tableIndex, rowIndex, fieldName, value, type) => {
    // Validation for percentage and number fields
    // if (type === "number" && !/^\d*$/.test(value)) return;
    if (type === "percentage" && !validatePercentage(value)) return;
    if (type === "number" && !validateNumberInput(value)) return;

    const updatedTables = [...tables];
    updatedTables[tableIndex].table[rowIndex][fieldName] = value;

    const totalCategory =
      parseFloat(updatedTables[tableIndex].table[rowIndex]["totalCategory"]) ||
      0;
    const antiCorruptionPolicies =
      parseFloat(
        updatedTables[tableIndex].table[rowIndex]["antiCorruptionPolicies"]
      ) || 0;

    const updatedErrors = { ...errors };

    if (antiCorruptionPolicies > totalCategory) {
      // Show validation error if antiCorruptionPolicies > totalCategory
      if (!updatedErrors[tableIndex]) updatedErrors[tableIndex] = {};
      if (!updatedErrors[tableIndex][rowIndex])
        updatedErrors[tableIndex][rowIndex] = {};

      updatedErrors[tableIndex][rowIndex]["antiCorruptionPolicies"] =
        "Anti-Corruption Policies cannot be greater than Total Category.";

      updatedTables[tableIndex].table[rowIndex]["percentage"] = ""; // Reset percentage
    } else {
      // Remove error if condition is valid
      if (
        updatedErrors[tableIndex] &&
        updatedErrors[tableIndex][rowIndex] &&
        updatedErrors[tableIndex][rowIndex]["antiCorruptionPolicies"]
      ) {
        delete updatedErrors[tableIndex][rowIndex]["antiCorruptionPolicies"];
        if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
          delete updatedErrors[tableIndex][rowIndex];
        }
        if (Object.keys(updatedErrors[tableIndex]).length === 0) {
          delete updatedErrors[tableIndex];
        }
      }

      // Calculate percentage only if valid
      if (totalCategory > 0 && antiCorruptionPolicies >= 0) {
        const percentage = (antiCorruptionPolicies / totalCategory) * 100;
        updatedTables[tableIndex].table[rowIndex]["percentage"] =
          fixedPercentage(percentage);
      }
    }

    setErrors(updatedErrors);
    setTables(updatedTables);
  };

  console.log("logerror", errors);

  return (
    <Box>
      <DeleteTableDialog
        openDialog={openDeleteDialog}
        cancelDelete={() => setOpenDeleteDialog(false)}
        confirmDelete={() => {
          deleteTable(tableToDelete);
          setOpenDeleteDialog(false);
        }}
      />

      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          mt: 2,
          textIndent: "-1rem",
          paddingLeft: "1rem",
        }}
        gutterBottom
      >
        {inputData[0].title}
      </Typography>
      {tables.map((table, tableIndex) => (
        <Box key={tableIndex} sx={{ mb: 4, marginLeft: "1rem", width: "98%" }}>
          <TableCell sx={{ padding: "3px" }}>{`Region ${
            tableIndex + 1
          }`}</TableCell>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
              width: "100%",
            }}
          >
            <TextField
              // placeholder={`Enter Region ${tableIndex + 1}`}
              placeholder={`Enter Text`}
              fullWidth
              sx={{
                width: "30%",
                height: "40px",
                "& .MuiInputBase-root": {
                  height: "40px",
                },
                "& .MuiInputBase-input": {
                  padding: "8px",
                  fontSize: "14px",
                },
              }}
              value={table.region} // Bind value to the region field
              onChange={(e) => {
                const updatedTables = [...tables];
                updatedTables[tableIndex].region = e.target.value; // Update the region field
                setTables(updatedTables);
              }}
              disabled={disabled}
            />

            {tables.length > 1 && (
              <IconButton
                color="error"
                onClick={() => handleDeleteTable(tableIndex)}
                sx={{ width: "5%" }}
                disabled={disabled}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </Box>

          <TableContainer
            component={Paper}
            sx={{
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              borderRadius: "10px",
            }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#1C486B" }}>
                  <TableCell
                    sx={{
                      color: "white",
                      fontWeight: 600,
                      borderRight: "1px solid #D3D3D3",
                    }}
                  >
                    S. No.
                  </TableCell>
                  {inputData[0].fields.map((field, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        color: "white",
                        fontWeight: 600,
                        borderRight: "1px solid #D3D3D3",
                        width: field.width,
                        maxWidth: field.width,                      }}
                    >
                      {field.title}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {table?.table.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    <TableCell
                      sx={{
                        borderRight: "1px solid #D3D3D3",
py:"0.5rem",
                        lineHeight: "1.2",
                        textAlign: "center",
                        width: "8%",
                      }}
                    >
                      {rowIndex + 1}.
                    </TableCell>

                    <TableCell
                      sx={{
                        borderRight: "1px solid #D3D3D3",
                        width: "30%",
                        color: "#1C5B8D",
                        py: "0.5rem",
                        lineHeight: "1.2",
                      }}
                    >
                      {row.employeeCategory}
                    </TableCell>

                    {inputData[0].fields.slice(1).map((field, fieldIndex) => (
                      <TableCell
                        key={fieldIndex}
                        sx={{
                          borderRight: "1px solid #D3D3D3",
                          backgroundColor:
                            field.fieldName === "percentage" ? "#EFEFEF" : "",
                            py: "0.5rem",
                            lineHeight: "1.2",
                            width: field.width,
                            maxWidth: field.width,
                        }}
                      >
                        <TextField
                          value={row[field.fieldName] || ""}
                          onChange={(e) =>
                            handleInputChange(
                              tableIndex,
                              rowIndex,
                              field.fieldName,
                              e.target.value,
                              field.type
                            )
                          }
                          // sx={{
                          //   "& .MuiOutlinedInput-root": {
                          //     borderRadius: 0,
                          //     "& fieldset": {
                          //       border: "none",
                          //     },
                          //   },
                          // }}
                          size="small"
                                  variant="standard"
                                  InputProps={{ disableUnderline: true }}
                          placeholder={field.placeholder}
                          fullWidth
                          disabled={field1===field?.fieldName || disabled}
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ mt: 1 }}>
            {errors[tableIndex] &&
              Object.entries(errors[tableIndex]).map(([rowIdx, rowErrors]) =>
                Object.entries(rowErrors).map(([field, errorMsg], idx) => (
                  <Typography
                    variant="body2"
                    color="error"
                    key={`${rowIdx}-${field}-${idx}`}
                    style={{
                      lineHeight: "1.2",
                      margin: "2px 0",
                      color: "#d34040",
                      fontSize: "10px",
                      fontStyle: "italic",
                    }}
                  >
                    {`Row ${parseInt(rowIdx) + 1}, ${field}: ${errorMsg}`}
                  </Typography>
                ))
              )}
          </Box>
        </Box>
      ))}

      {!hide && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "-1rem",
          }}
        >
          <Button
            endIcon={<Add />}
            onClick={handleAddTable}
            disabled={!isTableComplete() || disabled}
            sx={{
              color: "#1C486B",
              width: "14rem",
              borderColor: "#1C486B",
            }}
            variant="outlined"
          >
            Add New Region
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default RegionTable;
